module.exports = __webpack_public_path__ + "static/media/Phan_Nhat_Huy.7f0c4d63.jpg";